module.exports = __webpack_public_path__ + "static/img/line-chart.d1aa8a5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/line-chart.svg
// module id = CKop
// module chunks = 4